import React, { Component } from 'react';
import './picturebox.css';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import { layer } from '@fortawesome/fontawesome-svg-core';
//import InputMask from 'react-input-mask';



class PictureBox extends Component {
    constructor(props) {
      super(props);
      // PROPS
      /*
        --config={color:"#aad",readOnly:false/true, maxLength:0, textAlign:"left/center/right"}
          // color = hexa color for CSS text
          // readOnly = bool remove input to a read only textbox
          // maxlength = char max, if 0 no limit
          // textAlign = how to handle text position
        --updateValue  //callbackMethod
      */
        this.state = {
        };

  }


  // INNER METHOD

  

  // ---------------------RENDER --------------------- 
  render() {
    var style = {width:this.props.config.width, height:this.props.config.height};
    return (
          <div className={"picturebox"} style={style}>
          </div>
    );
  }
}
  
  const mapStateToProps = (state) => {    
    return {  
      
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(PictureBox);
  